import { useCallback } from "react"

import { Icon, Popup } from "semantic-ui-react"
import type { OpenAPI } from "simplydo/interfaces"

import api from "api"
import { EmojiChooser } from "components/lib/Choosers"
import { TooltipButton } from "components/lib/UI"
import { useAppSelector } from "store"
import constants from "utils/constants"
import util from "utils/utils"

type LabelActionProps = {
  idea: OpenAPI.GET<"/ideas/{id}">["response"]
  onUpdateIdea: (idea: Partial<OpenAPI.Schemas["Idea"]>) => void
}

const LabelAction = ({ idea, onUpdateIdea }: LabelActionProps) => {
  const user = useAppSelector((state) => state.user)

  const labelIdea = useCallback(
    (label, isApplied) => {
      const stamps = idea?.stamps ?? []
      let existingIndex = stamps.indexOf(label)
      if (label in constants.legacyStampMapper) {
        existingIndex = stamps.indexOf(constants.legacyStampMapper[label])
        if (existingIndex < 0) {
          existingIndex = stamps.indexOf(label)
        }
      }
      if (isApplied && existingIndex === -1) stamps.push(label)
      if (!isApplied && existingIndex > -1) stamps.splice(existingIndex, 1)
      api.ideas.updateStatus(
        idea._id,
        { stamps },
        () => {
          onUpdateIdea({ stamps })
        },
        () => {},
      )
    },
    [idea, onUpdateIdea],
  )

  if (
    !util.canManageChallenge(user, idea.ownerChallenge) &&
    !util.hasPermission(user, "challenge.editIdeaLabels", idea.challenge)
  ) {
    return null
  }

  return (
    <Popup
      on="click"
      trigger={
        <div>
          <TooltipButton icon tooltip="Label idea">
            <Icon name="paint brush" />
          </TooltipButton>
        </div>
      }
      content={
        <EmojiChooser
          onComplete={(em) => labelIdea(em, true)}
          existing={idea?.stamps}
          onRemoveExisting={(em) => labelIdea(em, false)}
        />
      }
    />
  )
}

export default LabelAction
